import React from 'react'

const ExportIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(-968, -284)" stroke={color}>
          <g transform="translate(270, 263)">
            <g transform="translate(691, 21)">
              <g transform="translate(7, -0)">
                <g transform="translate(1.3333, 1.3333)">
                  <path d="M13.3333333,8 L13.3333333,12 C13.3333333,12.7363797 12.7363797,13.3333333 12,13.3333333 L1.33333333,13.3333333 C0.596953667,13.3333333 0,12.7363797 0,12 L0,8"></path>
                  <polyline points="3.33333333 3.33333333 6.66666667 0 10 3.33333333"></polyline>
                  <line x1="6.66666667" y1="0" x2="6.66666667" y2="8"></line>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ExportIcon
